import React from 'react';
import '../Css_files/GalleryGrid.css';
import AchievementCard from './AchievementCard';

const GalleryGrid = ({ achievements, viewMode, onImageClick }) => {
  if (viewMode === 'list') {
    return (
      <div className="gallery-list">
        {achievements.map((achievement) => (
          <AchievementCard
            key={achievement.id}
            achievement={achievement}
            viewMode={viewMode}
            onImageClick={onImageClick}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="gallery-grid">
      {achievements.map((achievement) => (
        <AchievementCard
          key={achievement.id}
          achievement={achievement}
          viewMode={viewMode}
          onImageClick={onImageClick}
        />
      ))}
    </div>
  );
};

export default GalleryGrid;